// Customers logos

import bankOfAmericaLogo from '@framework/assets/customers/svg/bankOfAmerica.svg';
import barclaysLogo from '@framework/assets/customers/svg/barclays.svg';
import blackRockLogo from '@framework/assets/customers/svg/blackRock.svg';
import blackstoneLogo from '@framework/assets/customers/svg/blackstone.svg';
import carlyleLogo from '@framework/assets/customers/svg/carlyle.svg';
import CIBCLogo from '@framework/assets/customers/svg/CIBC.svg';
import citigroupLogo from '@framework/assets/customers/svg/citigroup.svg';
import dellLogo from '@framework/assets/customers/svg/dell.svg';
import fordLogo from '@framework/assets/customers/svg/ford.svg';
import goldmanSachsLogo from '@framework/assets/customers/svg/goldmanSachs.svg';
import guggenheimLogo from '@framework/assets/customers/svg/guggenheim.svg';
import hertzLogo from '@framework/assets/customers/svg/hertz.svg';
import holidayInnLogo from '@framework/assets/customers/svg/holidayInn.svg';
import houlihanLokeyLogo from '@framework/assets/customers/svg/houlihanLokey.svg';
import jefferiesLogo from '@framework/assets/customers/svg/jefferies.svg';
import mizuhoLogo from '@framework/assets/customers/svg/mizuho.svg';
import KKRLogo from '@framework/assets/customers/svg/KKR.svg';
import lazardLogo from '@framework/assets/customers/svg/lazard.svg';
import moelisLogo from '@framework/assets/customers/svg/moelis.svg';
import nomuraLogo from '@framework/assets/customers/svg/nomura.svg';
import piperSandlerLogo from '@framework/assets/customers/svg/piperSandler.svg';
import soFiLogo from '@framework/assets/customers/svg/soFi.svg';
import solomonPartnersLogo from '@framework/assets/customers/svg/solomonPartners.svg';
import teslaLogo from '@framework/assets/customers/svg/tesla.svg';
import thomabravoLogo from '@framework/assets/customers/svg/thomabravo.svg';
import verizonLogo from '@framework/assets/customers/svg/verizon.svg';
import wellsFargoLogo from '@framework/assets/customers/svg/wellsFargo.svg';
import williamBlairLogo from '@framework/assets/customers/svg/williamBlair.svg';

export default [
  {
    src: bankOfAmericaLogo.src,
    title: 'Bank Of America',
  },
  {
    src: barclaysLogo.src,
    title: 'Barclays',
  },
  {
    src: blackRockLogo.src,
    title: 'Black Rock',
  },
  {
    src: blackstoneLogo.src,
    title: 'Blackstone',
  },
  {
    src: carlyleLogo.src,
    title: 'Carlyle',
  },
  {
    src: CIBCLogo.src,
    title: 'CIBC',
  },
  {
    src: citigroupLogo.src,
    title: 'Citigroup',
  },
  {
    src: dellLogo.src,
    title: 'Dell',
  },
  {
    src: fordLogo.src,
    title: 'Ford',
  },
  {
    src: goldmanSachsLogo.src,
    title: 'Goldman Sachs',
    width: 71,
    height: 30,
  },
  {
    src: guggenheimLogo.src,
    title: 'Guggenheim',
  },
  {
    src: hertzLogo.src,
    title: 'Hertz',
  },
  {
    src: holidayInnLogo.src,
    title: 'Holiday Inn',
  },
  {
    src: houlihanLokeyLogo.src,
    title: 'Houlihan Lokey',
  },
  {
    src: jefferiesLogo.src,
    title: 'Jefferies',
  },
  {
    src: KKRLogo.src,
    title: 'KKR',
  },
  {
    src: lazardLogo.src,
    title: 'Lazard',
  },
  {
    src: mizuhoLogo.src,
    title: 'Mizuho',
  },
  {
    src: moelisLogo.src,
    title: 'Moelis',
  },
  {
    src: nomuraLogo.src,
    title: 'Nomura',
  },
  {
    src: piperSandlerLogo.src,
    title: 'Piper Sandler',
  },
  {
    src: soFiLogo.src,
    title: 'SoFi',
  },
  {
    src: solomonPartnersLogo.src,
    title: 'Solomon Partners',
  },
  {
    src: teslaLogo.src,
    title: 'Tesla',
  },
  {
    src: thomabravoLogo.src,
    title: 'Thomabravo',
  },
  {
    src: verizonLogo.src,
    title: 'Verizon',
  },
  {
    src: wellsFargoLogo.src,
    title: 'Wells Fargo',
  },
  {
    src: williamBlairLogo.src,
    title: 'Willoam Blair',
  },
];
